const carouselItems = [
  {
    title: '2026上半年娱乐圈大事件全复盘',
    desc: '从年初到6月，娱乐圈发生了哪些值得铭记的大瓜？一文带你完整回顾。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20entertainment%20year%20review%20with%20warm%20coral%20and%20amber%20tones%2C%20abstract%20timeline%20shapes%2C%20modern%20magazine%20layout%2C%20clean%20sophisticated%20design%20with%20soft%20gradient%20background&width=600&height=360&seq=car-01-51cg&orientation=landscape',
  },
  {
    title: '顶流塌房经济学：一个瓜值多少钱？',
    desc: '顶流明星翻车背后涉及的品牌解约、违约金、商业损失深度分析。',
    img: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20visual%20of%20celebrity%20endorsement%20crisis%20and%20brand%20impact%20analysis%2C%20warm%20amber%20color%20scheme%2C%20abstract%20financial%20chart%20elements%2C%20editorial%20design%20with%20clean%20lines%20and%20soft%20gradients&width=600&height=360&seq=car-02-51cg&orientation=landscape',
  },
  {
    title: '网红经济下半场：从涨粉到翻车',
    desc: '网红赛道越来越卷，翻车事件频发背后反映了怎样的行业生态变化？',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20internet%20celebrity%20economy%20and%20social%20media%20trends%2C%20warm%20coral%20gradients%2C%20abstract%20network%20connection%20shapes%2C%20modern%20editorial%20style%20with%20sophisticated%20composition&width=600&height=360&seq=car-03-51cg&orientation=landscape',
  },
  {
    title: '明星公关教科书：那些漂亮的危机应对',
    desc: '同样是翻车，为什么有些明星能全身而退？盘点近年最精彩的公关案例。',
    img: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20editorial%20visual%20of%20PR%20strategy%20and%20crisis%20management%20in%20entertainment%2C%20warm%20amber%20and%20peach%20color%20palette%2C%20abstract%20shield%20and%20strategy%20shapes%2C%20modern%20clean%20design&width=600&height=360&seq=car-04-51cg&orientation=landscape',
  },
  {
    title: '综艺节目名场面：那些载入史册的瞬间',
    desc: '从尴尬到爆笑，这些年综艺节目贡献了哪些让人终生难忘的经典画面？',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20variety%20show%20highlights%20and%20viral%20moments%2C%20warm%20coral%20tones%2C%20abstract%20spotlight%20and%20stage%20shapes%2C%20editorial%20magazine%20design%20with%20clean%20composition%20and%20soft%20gradients&width=600&height=360&seq=car-05-51cg&orientation=landscape',
  },
  {
    title: '吃瓜群众行为图鉴：你是哪种吃瓜人？',
    desc: '理性分析型、跟风站队型、考古挖坟型……测测你属于哪一类吃瓜选手。',
    img: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20illustration%20of%20social%20media%20user%20behavior%20types%20and%20online%20community%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20abstract%20personality%20icon%20shapes%2C%20modern%20editorial%20design%20with%20clean%20aesthetic&width=600&height=360&seq=car-06-51cg&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            深度策划的吃瓜专题，一次看个够
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {carouselItems.map((item) => (
              <div
                key={item.title}
                className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:bg-background-50/80 transition-colors"
              >
                <div className="relative aspect-[5/3] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}